<template>
  <p class="lead">
    <slot></slot>
  </p>
</template>

<script>
export default {
  name: 'timeline-lead',
  props: {}
};
</script>

<style>
  @media (min-width: 768px) {
    .lead {
      font-size: 16px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/UIComponents/Timeline/TimelineLead.vue